import { Role, rolesManipulator } from 'auth';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { employeeDashboardPaths } from '@/modules/employee-dashboard/routes.tsx';
import { Spinner } from 'ui';

export const mapRoleToDefaultRoute: Partial<Record<Role, string>> = {
  [Role.COMPLIANCE_USER]: employeeDashboardPaths.static.dashboard,
  [Role.COMPLIANCE_ADMIN]: adminDashboardPaths.static.dashboard,
};

const RootRoute = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated && rolesManipulator.current_user_role) {
      navigate({
        pathname: mapRoleToDefaultRoute[rolesManipulator.current_user_role] || '/',
        search: location.search,
      });
      return;
    }
  }, [auth.isAuthenticated, navigate]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
};

export default withPrivateAccess(RootRoute, [Role.COMPLIANCE_USER, Role.COMPLIANCE_ADMIN]);
